import { createContext, useContext, useState, useEffect } from 'react';

const CompanyAuthContext = createContext(null);

export function CompanyAuthProvider({ children }) {
  const [companyUser, setCompanyUser] = useState(null);
  const [loading, setLoading]         = useState(true);

  useEffect(() => {
    const raw = localStorage.getItem('cp_token');
    if (raw) {
      try {
        const payload = JSON.parse(atob(raw.split('.')[1]));
        if (payload.exp * 1000 > Date.now()) {
          setCompanyUser(JSON.parse(localStorage.getItem('cp_user') || 'null'));
        } else {
          localStorage.removeItem('cp_token');
          localStorage.removeItem('cp_user');
        }
      } catch {
        localStorage.removeItem('cp_token');
        localStorage.removeItem('cp_user');
      }
    }
    setLoading(false);
  }, []);

  const login = (token, user) => {
    localStorage.setItem('cp_token', token);
    localStorage.setItem('cp_user', JSON.stringify(user));
    setCompanyUser(user);
  };

  const updateUser = (updates) => {
    const updated = { ...companyUser, ...updates };
    localStorage.setItem('cp_user', JSON.stringify(updated));
    setCompanyUser(updated);
  };

  const logout = () => {
    localStorage.removeItem('cp_token');
    localStorage.removeItem('cp_user');
    setCompanyUser(null);
  };

  return (
    <CompanyAuthContext.Provider value={{ companyUser, loading, login, updateUser, logout }}>
      {children}
    </CompanyAuthContext.Provider>
  );
}

export function useCompanyAuth() {
  return useContext(CompanyAuthContext);
}
